import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./GetStarted.css";
import clsx from "clsx";
import { Button } from "../../atoms/Button/StyledButton";
import Linkedin from "../../atoms/iconsComponent/Linkedin";
import useMediaQuery from "../../../hook/useMediaQuery";
import { MediaMobile, MediaTablet } from "../../../api/const/MediaQuery";
import { Logo } from "../../atoms";
import { StepperTemplate } from "../../templates";
import { getLinkedInAuthUrl } from "api/calls";
import { LinkedInRedirectType } from "api/const";


export const GetStarted = () => {
  const [route, setRoute] = useState("corporate");
  const tablet = useMediaQuery(MediaTablet)
  const mobile = useMediaQuery(MediaMobile)
  const buttonsColumns = useMediaQuery(1110)
  const navigate = useNavigate();
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.toLowerCase().includes(`startup`)) {
      return setRoute("startup")
    }
    return setRoute("corporate")
  }, [location])

  const registerWithLinkedin = () => {
    //navigate(`/getStarted/${route}`)
    //API return LinkedIn redirect URL
    getLinkedInAuthUrl(LinkedInRedirectType.REGISTER).then((resp) => {
      if (resp.isSuccess && !!resp.response?.data) {
        window.location.replace(resp.response.data)
      }
    })

  }

  return (
    <StepperTemplate>
      {tablet && !mobile &&
        <h2 className="mb-3 mt-3 ">Join in Innovation Match,  where innovation takes place</h2>
      }
      {mobile &&
        <h3 className="mb-3 mt-3 ">Join in Innovation Match, where innovation takes place</h3>
      }
      <p className="link-primary-pink animate__flash mt-5">
        Select your membership type
      </p>
      <h3 className={clsx(" fw-400  ",
        { "mt-3": !tablet },
        { "mt-0": tablet }
      )}>You are</h3>

      {/* A START UP */}
      <div className="d-flex align-items-center cursor-pointer ">
        <div>
          <Logo className={clsx("logo-select me-2 transition-01", {
            "select-disabled": route !== "startup",
          })} colorLogo={route !== "startup" ? "#000000" : "#FF3F6B"} />
        </div>
        <h3
          className={clsx("fw-700 transition-01 ", {
            "select-disabled": route !== "startup",
          })}
          onClick={() => {
            setRoute("startup");
          }}
        >
          an Innovation Provider
        </h3>
      </div>
      <h6
        className={clsx("transition-01 ", {
          "select-disabled": route !== "startup",
        })}
        onClick={() => {
          setRoute("startup");
        }}
      >
        <p>
          You are a company or a startup that offers innovative solutions, technologies, or ideas to address specific business challenges or needs.
        </p>
        <p>

          You want to sell your innovative solution to corporate managers.
        </p>
      </h6>
      {/* A CORPORATES */}
      <div className="d-flex align-items-center cursor-pointer mt-2">
        <div>
          <Logo className={clsx("logo-select me-2 transition-01", {
            "select-disabled": route !== "corporate",
          })} colorLogo={route !== "corporate" ? "#000000" : "#FF3F6B"} />
        </div>
        <h3
          className={clsx("fw-700 transition-01  ", {
            "select-disabled": route !== "corporate",
          })}
          onClick={() => {
            setRoute("corporate");
          }}
        >
          an Innovation Seeker
        </h3>
      </div>
      <h6
        className={clsx("transition-01 ", {
          "select-disabled": route !== "corporate",
        })}
        onClick={() => {
          setRoute("corporate");
        }}
      >
        <p>
          You are a Corporate Manager seeking innovative solutions to address specific business needs or challenges in your company.
        </p>
        <p>
          Register for free to scout new innovative solutions and send match requests.
        </p>
      </h6>
      <div
        className={clsx(
          "d-flex w-100  mt-3",
          { "justify-content-end w-50": route === "start-up" },
          { "justify-content-between": route === "corporate" },
          { "flex-row": !buttonsColumns },
          { "flex-column": buttonsColumns }
        )}
      >
        {route === "corporate"
          ? <Button
            borderColor="var(--linkedin)"
            color="var(--linkedin)"
            className={clsx(" linkedin-button",
              { "mt-1 ms-1": !buttonsColumns },
              { "mb-3 ms-0": buttonsColumns },
              { "fs-11 w-100": mobile }
            )}
            background="var(--white)"
            icon={<Linkedin className="started-linkedin" />}
            fontWeight={"800"}
            uppercase
            text="register with linkedin"
            onClick={registerWithLinkedin}
          />
          : <Button
            className="mt-1 ms-1 mb-1"
            color="var(--white)"
            background="var(--primary)"
            borderColor="var(--primary)"
            fontWeight={"800"}
            uppercase
            primary
            text="start"
            onClick={() => navigate(`/getStarted/${route}`)}
          />
        }


      </div>
    </StepperTemplate>
  );
};
